export const WORKER_URL = 'https://server.gamanza-games.workers.dev';
// export const WORKER_URL = 'http://localhost:8787';